import React, {ReactNode} from 'react';
import {useChatContext} from "./ChatContext";
import {getSetting} from "./utils/settings";
import {__} from "@wordpress/i18n";
import {destroyHistory} from "./api/requests";

const ClearButton: React.FC = () => {
    const allowed = getSetting( 'appearance.allow_deleting' );

    if ( ! allowed ) {

        return null;
    }

    const { history } = useChatContext();

    const destroySession = async () => {
        if ( !confirm( __( 'Verlauf leeren?', 'wv-chat-bot' ) ) ) {

            return;
        }

        try {
            await destroyHistory();
            history.clearHistory();
        }

        // If any error occurs during the fetch or processing, we catch it and display an error message in the chat
        catch (error) {
            console.log(error);
        }
    }

    return (
        <button id="wvcb__clear-button" onClick={destroySession}></button>
    );
};

const CloseButton: React.FC = () => {
    const { chat } = useChatContext();

    return (
        <button id="wvcb__close-button" onClick={chat.close}></button>
    );
};


const MaximizeButton: React.FC = () => {
    const allowed = getSetting( 'appearance.allow_maximizing' );

    if ( ! allowed ) {

        return null;
    }

    const { chat } = useChatContext();

    return !chat.isMaximized()
        ? ( <button id="wvcb__maximize-button" onClick={chat.maximize}></button> )
        : ( <button id="wvcb__minimize-button" onClick={chat.minimize}></button> );
};

export const Window = ({children}: {children: ReactNode}) => {
    const heading = getSetting('appearance.heading');

    return (
        <div id="wvcb__window">

            <header id="wvcb__header">
                <h2 id="wvcb__heading">{heading}</h2>
                <div id="wvcb__buttons">
                    <ClearButton/>
                    <MaximizeButton/>
                    <CloseButton/>
                </div>
            </header>

            {children}

        </div>
    );
};
